export default {
  props: {
    announcement: {
      type: Object,
      required: true,
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/announcement/announcement.js